import { render, staticRenderFns } from "./ForaDoAr.vue?vue&type=template&id=d8f8de68&scoped=true&"
import script from "./ForaDoAr.vue?vue&type=script&lang=js&"
export * from "./ForaDoAr.vue?vue&type=script&lang=js&"
import style0 from "./ForaDoAr.vue?vue&type=style&index=0&id=d8f8de68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f8de68",
  null
  
)

export default component.exports